export default __webpack_public_path__ + "static/media/banner-seguro-saude-empresarial-desktop.17481a0b.png";